module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/results-download/results-download.component.css
// module id = ./src/app/results-download/results-download.component.css
// module chunks = main